export const selectDefaultVehicle = user => user && user.defaultVehicleId

export const selectDefaultVehicleId = state => state.user?.me?.defaultVehicleId

export const selectVehicleById = (state, vehicleId) =>
  state.user?.me?.vehicles?.find(vehicle => vehicle.id === vehicleId)
